import { useContext } from 'react';
import { MenuActionControlProviderContext, MenuActionControlProviderContextType } from '#baseMenu/contexts';

// eslint-disable-next-line max-len
const useMenuActionControlProviderContext = () => useContext<MenuActionControlProviderContextType>(MenuActionControlProviderContext);

export { useMenuActionControlProviderContext };
